// Custom inline SVG icons for ONE YORK additional services
// All use currentColor; sized via parent CSS (size prop optional).

export const GoogleGIcon = ({ size = 18, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#4285F4"
      d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"
    />
    <path
      fill="#34A853"
      d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"
    />
    <path
      fill="#FBBC05"
      d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z"
    />
    <path
      fill="#EA4335"
      d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"
    />
  </svg>
);

const baseProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

/* 02 — CAR SEAT: clear bucket seat with backrest, headrest and base */
export const CarSeatIcon = (props) => (
  <svg {...baseProps} {...props}>
    {/* headrest */}
    <rect x="9" y="2" width="6" height="3" rx="1" />
    {/* backrest */}
    <path d="M7 5h10v9H7z" />
    {/* contour bolsters */}
    <path d="M9 7v5" />
    <path d="M15 7v5" />
    {/* seat cushion */}
    <path d="M5 14h14l-1.5 4.5a2 2 0 0 1-1.9 1.5H8.4a2 2 0 0 1-1.9-1.5z" />
  </svg>
);

/* 03 — ROTARY POLISHER: disc + handle + grip */
export const PolisherIcon = (props) => (
  <svg {...baseProps} {...props}>
    {/* polishing pad */}
    <circle cx="8" cy="16" r="5" />
    <circle cx="8" cy="16" r="1.5" />
    {/* shaft */}
    <path d="m12 12 4-4" />
    {/* motor body */}
    <rect
      x="14.5"
      y="4.5"
      width="6"
      height="5"
      rx="1.2"
      transform="rotate(45 17.5 7)"
    />
    {/* speed line */}
    <path d="m20 12 1 1" />
  </svg>
);

/* 04 — CAR HEADLIGHT: rounded reflector + bulb + beams */
export const HeadlightIcon = (props) => (
  <svg {...baseProps} {...props}>
    {/* reflector housing */}
    <path d="M3 9.5a3.5 3.5 0 0 1 3.5-3.5h4A3.5 3.5 0 0 1 14 9.5v5a3.5 3.5 0 0 1-3.5 3.5h-4A3.5 3.5 0 0 1 3 14.5z" />
    {/* inner ring */}
    <path d="M5.5 10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z" />
    {/* light beams */}
    <path d="M16 8.5h2.5" />
    <path d="M16 12h4" />
    <path d="M16 15.5h2.5" />
  </svg>
);

/* 05 — CAR ENGINE: classic engine warning silhouette */
export const EngineIcon = (props) => (
  <svg {...baseProps} {...props}>
    {/* main block */}
    <path d="M3 10h2V8h3v2h2V7h6v3h3a1 1 0 0 1 1 1v2h-1v2h1v2a1 1 0 0 1-1 1h-3v-2h-2v2H7v-2H5v-2H3v-4z" />
    {/* spark plug */}
    <path d="M11 7V4.5h2V7" />
    {/* fluid cap */}
    <path d="M14.5 4.5h.001" />
  </svg>
);

/* 06 — UNDERCARRIAGE: chassis frame + wheels + cross members */
export const UndercarriageIcon = (props) => (
  <svg {...baseProps} {...props}>
    {/* outer chassis rectangle */}
    <rect x="3" y="8" width="18" height="6" rx="0.8" />
    {/* longitudinal beam */}
    <path d="M3 11h18" />
    {/* cross members */}
    <path d="M8 8v6" />
    <path d="M13 8v6" />
    <path d="M17 8v6" />
    {/* wheels (front & rear axles) */}
    <circle cx="7" cy="17.5" r="2" />
    <circle cx="17" cy="17.5" r="2" />
  </svg>
);

/* 07 — EXTERIOR CERAMIC SEALANT: shield + droplet + snowflake */
export const CeramicSealantIcon = (props) => (
  <svg {...baseProps} {...props}>
    {/* shield outline */}
    <path d="M12 2.5 4 5v6c0 4.6 3.5 8.3 8 9.5 4.5-1.2 8-4.9 8-9.5V5z" />
    {/* water droplet */}
    <path d="M9 10.5c-1 1.2-1.5 2.1-1.5 3a1.7 1.7 0 0 0 3.4 0c0-.9-.5-1.8-1.5-3z" />
    {/* snowflake */}
    <path d="M15.5 12v5" />
    <path d="M13.5 14.5h4" />
    <path d="m14 13 3 3" />
    <path d="m14 16 3-3" />
  </svg>
);

/* WHATSAPP — official brand mark (speech-bubble + receiver) */
export const WhatsAppIcon = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M27.215 4.785A15.83 15.83 0 0 0 16 .14 15.86 15.86 0 0 0 2.144 23.78L0 31.86l8.276-2.17a15.84 15.84 0 0 0 7.717 1.965h.007c8.736 0 15.85-7.114 15.853-15.857a15.78 15.78 0 0 0-4.638-11.213zM16 28.974h-.005a13.16 13.16 0 0 1-6.71-1.837l-.481-.286-4.91 1.287 1.31-4.787-.314-.495a13.16 13.16 0 0 1-2.018-7.018c.003-7.27 5.916-13.18 13.183-13.18a13.1 13.1 0 0 1 9.32 3.866 13.07 13.07 0 0 1 3.857 9.323c-.003 7.273-5.916 13.183-13.183 13.183zm7.232-9.866c-.396-.198-2.346-1.158-2.71-1.29-.363-.132-.628-.198-.892.198-.265.396-1.024 1.29-1.255 1.555-.231.265-.462.297-.858.099-.396-.198-1.673-.617-3.187-1.967-1.178-1.052-1.973-2.35-2.204-2.746-.231-.396-.024-.61.174-.808.178-.178.396-.462.594-.693.198-.231.264-.396.396-.66.132-.265.066-.495-.033-.693-.099-.198-.892-2.15-1.222-2.94-.322-.773-.65-.668-.892-.68-.231-.013-.495-.015-.76-.015a1.46 1.46 0 0 0-1.057.495c-.363.396-1.387 1.354-1.387 3.305s1.42 3.834 1.617 4.099c.198.265 2.795 4.267 6.769 5.984.946.408 1.683.652 2.258.834.949.301 1.812.259 2.495.157.762-.114 2.346-.96 2.677-1.886.33-.926.33-1.72.231-1.886-.099-.165-.363-.264-.76-.462z" />
  </svg>
);

